import { privateAxios } from "../axiosInstances";

export const getEventTicketsAsCsv = async (eventId: string) => {
  const { data } = await privateAxios.get<string>(
    `/events/${eventId}/tickets/scan/export`
  );
  return data;
};

export const getExhibitorGuestsTicketsAsCsv = async (
  structureId: string,
  eventId: string
) => {
  const { data } = await privateAxios.get<string>(
    `/structures/${structureId}/visitors/tickets/${eventId}/export`
  );
  return data;
};

export const downloadExhibitorGuestTicketsAsZip = async (
  structureId: string,
  eventId: string,
): Promise<Blob | null> => {
  const response = await privateAxios.get<Blob>(
    `/structures/${structureId}/visitors/tickets/${eventId}/download-all`,
    { responseType: "blob" },
  );
  if (response.status === 204) return null;
  return response.data;
};

export const downloadExhibitorGuestBadgesAsZip = async (
  structureId: string,
  eventId: string,
): Promise<Blob | null> => {
  const response = await privateAxios.get<Blob>(
    `/structures/${structureId}/visitors/badges/${eventId}/download-all`,
    { responseType: "blob" },
  );
  if (response.status === 204) return null;
  return response.data;
};
